import { Form, Formik } from 'formik';
import { useState } from 'react';

import FormField from '../FormField';
import { inviteMerchantSchema } from './schema/invite-merchant-schema';

import Button from '@/components/ui/button';
import { IInviteMerchantPayload } from '@/interfaces/api/store/IInviteMerchantPayload';
import { haggleApiService } from '@/services/haggle.service';
import { notificationService } from '@/services/notification.service';

const values: IInviteMerchantPayload = {
	name: '',
	email: '',
};

type PropTypes = {
	refetchStore: () => void;
};

const InviteMerchantForm = ({ refetchStore }: PropTypes) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async (
		values: IInviteMerchantPayload,
		{ resetForm }: { resetForm: () => void },
	) => {
		const { email, name } = values;
		setIsLoading(true);
		try {
			await haggleApiService.inviteUser(email, name);
			refetchStore();
			notificationService.success('User invited successfully');
			resetForm();
		} catch (error) {
			if (error instanceof Error) {
				notificationService.error(error.message);
			} else {
				notificationService.error(
					`Unknown error when trying to create the user: ${error}`,
				);
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="flex flex-col w-full p-4" data-test="invite-merchant-form">
			<Formik
				initialValues={values}
				onSubmit={(values, { resetForm }) =>
					handleSubmit(values, { resetForm })
				}
				validationSchema={inviteMerchantSchema}
			>
				{() => (
					<Form className="flex flex-wrap gap-2 justify-between w-full">
						<div className="w-full">
							<FormField
								name="name"
								label="Name"
								type="text"
								placeholder="Name"
							/>
						</div>

						<div className="w-full">
							<FormField
								name="email"
								label="Email"
								type="email"
								placeholder="test@mail.com"
							/>
						</div>

						<div className="border w-full" />
						<Button
							type="submit"
							className="w-full my-2"
							shape="rounded"
							isLoading={isLoading}
							disabled={isLoading}
							data-test="submit-invite-merchant-button"
						>
							Submit
						</Button>
					</Form>
				)}
			</Formik>
		</div>
	);
};
export default InviteMerchantForm;
